<template>
  <div class="social__group">
    <a
      :href="$beet.options.socials[social]"
      v-for="(social, socialKey) in socials"
      :key="socialKey"
      :title="social"
      target="_blank"
      class="social"
    >
      <Icon :id="social" />
    </a>
  </div>
</template>

<script>
import { Icon } from '@/components/global'

export default {
  name: 'Socials',
  components: { Icon },
  data() {
    return {
      socials: ['facebook', 'instagram', 'linkedin'],
    }
  },
}
</script>
